import { render } from "./RuiChat.vue?vue&type=template&id=a25b9064"
const script = {}
script.render = render

export default script